import { windowStyleOptions } from "../types";
import { SelectSystemEnum, SelectSystemEnumProps, InputRadioGroup } from "@components-common/forms";

/**
 * WindowStyleSelector Component
 * 
 * Renders a radio group for selecting a window style.
 * 
 * @param {SelectSystemEnumProps} props - The properties for the window style selector component.
 * @param {string} [props.id="style"] - The unique identifier for the input fields, defaults to "style".
 * @returns {JSX.Element} - The rendered window style selector component.
 */
export const WindowStyleSelector = ({id = "style",...rest}: SelectSystemEnumProps) => (
  <InputRadioGroup id={id} {...rest} elementClass={`mt-2 ${rest.elementClass ? rest.elementClass : ""}`} options={windowStyleOptions}/>
);
